<template>
  <div>
    <el-tree
      ref="tree"
      class="department"
      :data="VMTreeData"
      :props="defaultProps"
      :expand-on-click-node="false"
      node-key="id"
      :filter-node-method="filterNode"
      default-expand-all
      :highlight-current="true"
      :show-checkbox="!disabledNode"
      @node-click="handleNodeClick"
      @check-change="handleCheckChange"
      @check="check"
    />
  </div>
</template>

<script>
export default {
  props: {
    showType: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: () => {
        return []
      }
    },
    filterText: {
      type: String,
      default: ''
    },
    //回显节点
    callNode: {
      type: Array,
      default: () => {
        return []
      }
    },
    //禁止节点选择
    disabledNode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: this.disabledChange
      },
      VMTreeData: [],
      setNodeTime: null, //构造当前选中节点的防重复定时器
      CheckChange: 0, //CheckChange计数器，第一次跳过
      isSetNodeList: [], //累积已经选中的节点，用于存储节点选择路径，用于backNode撤销节点
      nowSetNodeList: [], //当前选中的节点树，当前轮次节点选择路径
      nowSetNodeListMap: [], //当前当前选中的节点树map
      unCheckedNodeFlag: false, //当前是否在进行取消节点选择状态
      disabledNodeMap: {} //禁止选中的节点
    }
  },
  watch: {
    filterText (nv) {
      this.$refs.tree.filter(nv)
    },
    //回显节点
    callNode (nv) {
      this.showCallNode(nv)
    }
  },
  created () {
    this.initTree()
  },
  mounted () {
    this.showCallNode(this.callNode)
  },
  methods: {
    //回显节点
    showCallNode (callNode) {
      // console.log('callNode', callNode)
      if (!callNode.length) return
      callNode.forEach((node) => {
        this.$refs.tree.setChecked(node, true)
      })
    },
    //disabledChange
    disabledChange (data, node) {
      // console.log(data,node)
      // console.log('disabledChange11111',data,node,this.nowSetNodeListMap)

      // let getCheckedKeys = this.$refs.tree.getCheckedKeys(true,true)
      // console.log('节点getCurrentNode',getCheckedKeys)

      return this.nowSetNodeListMap.find((d) => d.id == data.id) ? true : false
      // if(this.nowSetNodeListMap['GNId'+data.id])
      //  setTimeout(()=>{

      //     delete this.nowSetNodeListMap['GNId'+data.id]
      // },200)
      // return !this.nowSetNodeListMap['GNId'+data.id]?false:true
      // return false
    },
    //初始化
    initTree () {
      console.log('this.disabledNode.initTree', this.disabledNode)
      this.VMTreeData = JSON.parse(JSON.stringify(this.treeData))
      // console.log('this.VMTreeData', this.VMTreeData)
    },
    //单击节点
    handleNodeClick (data) {
      console.log('handleNodeClick选中节点', { ...data })
      if (this.nowSetNodeListMap.find((d) => d.id == data.id)) return
      this.$emit('nodeChange', data)
    },
    //过滤节点
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    //check
    check (node, nodesList) {
      // console.log('treeBox-check',node, nodesList)
      this.nowSetNodeList.push(node)
      this.disabledNodeMap['GNId' + node.id] = node
      nodesList.halfCheckedNodes.forEach((d) => {
        d.disabled = true
        this.nowSetNodeList.push(d)
        this.disabledNodeMap['GNId' + d.id] = d
      })
      this.isSetNodeList['GNId' + node.id] = this.nowSetNodeList
      // this.$emit('getIsGNode',data)
      this.$emit('getIsGNode', node)
      this.nowSetNodeList = []
      // console.log('当前累积选中的NodeList this.isSetNodeList', { ...this.isSetNodeList })
    },
    //节点checkbox选择
    handleCheckChange (data, checked, indeterminate) {
      //阻止全公司选择
      // if(this.unCheckedNodeFlag)return

      // this.nowSetNodeList.push(data)
      // this.nowSetNodeListMap['GNId'+data.id] = data
      // setTimeout(()=>{
      // console.log('节点checkbox选择-handleCheckChange', { ...data }, checked, indeterminate)
      // let getCheckedKeyss = this.$refs.tree.getCheckedKeys(false,true)
      this.nowSetNodeListMap = this.$refs.tree.getCheckedNodes(false, true)

      // console.log('节点getCurrentNode1111111', this.nowSetNodeListMap)
      //   console.log('this.disabledNodeMap',this.disabledNodeMap)
      //   // data.disabled =  !this.disabledNodeMap['GNId'+data.id]?false:true
      // },300)

      // data.disabled = true
      // let time = 200

      //防抖动
      // if(!this.setNodeTime){
      //   this.setNodeTime = setTimeout(()=>{

      //     // this.setNodeTime = null
      //     // this.isSetNodeList['GNId'+data.id]= this.nowSetNodeList
      //     // // this.$emit('getIsGNode',data)
      //     // this.$emit('getIsGNode',this.nowSetNodeList[this.nowSetNodeList.length-1])
      //     // this.nowSetNodeList = []
      //     // console.log('当前累积选中的NodeList this.isSetNodeList',{...this.isSetNodeList})
      //   },time)
      // }
    },
    //撤销节点选中状态
    unCheckedNode (VMTD, Node) {
      // this.unCheckedNodeFlag = true
      let fNodes = this.isSetNodeList['GNId' + Node.id]
      if (!fNodes) {
        for (let i in this.isSetNodeList) {
          fNodes = this.isSetNodeList[i].find((d) => d.id == Node.id)
            ? this.isSetNodeList[i]
            : fNodes
        }
      }
      // console.log('撤销节点选中状态-treebox-unCheckedNode-Node3', Node, fNodes)

      Node.disabled = false

      // this.$refs.tree.setChecked(Node, false)
      this.unSetChecked(Node)
      if (!fNodes) return
      for (let N of fNodes) {
        // N.disabled = false
        this.$refs.tree.setChecked(N, false)
      }
      // Node.disabled = false
      // this.$refs.tree.setChecked([Node])
      // this.$refs.tree.setCheckedNodes([Node])
      // setTimeout(() => {
      //   this.unCheckedNodeFlag = false
      // }, 200)
    },
    //递归关闭子节点选中
    unSetChecked (Node) {
      this.$refs.tree.setChecked(Node, false)
      if (Node.children && Node.children.length) {
        for (let N of Node.children) {
          this.unSetChecked(N)
        }
      } else return
    }
  }
}
</script>
<style lang="scss" src="@/components/guideBox/tmps/index.scss" scoped></style>
<style lang="scss" scoped>
.box {
  border: 1px solid #dcdfe6;
  padding: 20px 0 20px 20px;
  border-radius: 5px;
  height: 520px;
}
.department {
  height: 420px;
  overflow: auto;
  padding-right: 10px;
}
.department::-webkit-scrollbar {
  display: none;
}
.dialog_btns {
  margin-top: 20px;
  text-align: right;
  &-sub {
    margin-right: 20px;
  }
}
</style>
